
import { defineComponent, reactive, toRefs } from 'vue';
import Overlay from '../../components/Overlay.vue';
import VChart from 'vue-echarts';

export default defineComponent({
  name: 'DashboardAllocatedAccomlpished',

  components: {
    Overlay,
    VChart,
  },

  props: {
    totalStockDelivery: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    channelInvoiceQtde: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    channelRevenueQtde: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    channelBudgetQtde: {
      type: Array as () => Array<number>,
      default: () => [],
    },

    day: {
      type: Array as () => Array<string>,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const propsRef = toRefs(props);
    const state = reactive({
      options: {
        backgroundColor: '#404040',
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '2%',
          top: '5%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: propsRef.day,
          axisLine: { show: true },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
        },
        yAxis: {
          type: 'value',
          position: 'right',
          axisLine: { show: false },
          axisLabel: { show: true },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: '#eeeeee',
              opacity: 0.2,
              width: 1,
            },
          },
        },
        series: [
          {
            name: 'Alocado',
            type: 'line',
            data: propsRef.channelInvoiceQtde,
            color: '#a9a29f',
            label: {
              show: false,
              color: '#ffffff',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
          {
            name: 'Entrada Produção',
            type: 'line',
            data: propsRef.totalStockDelivery,
            color: '#f56224',
            label: {
              show: false,
              color: '#ffffff',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
          {
            name: 'Faturado',
            type: 'line',
            data: propsRef.channelRevenueQtde,
            color: '#e6ea00',
            label: {
              show: false,
              color: '#ffffff',
              formatter: (i: any) => {
                return i.data[1] == 0 ? '' : i.data[1];
              },
            },
          },
          {
            name: 'Meta',
            type: 'line',
            data: propsRef.channelBudgetQtde,
            color: '#143168',
            label: {
              show: false,
              color: '#ffffff',
              formatter: (i: any) => {
                return i.dataIndex == 0
                  ? i.data[1].toFixed(0)
                  : i.dataIndex == propsRef.channelBudgetQtde.value.length - 1
                  ? i.data[1].toFixed(0)
                  : '';
              },
            },
          },
        ],
      },
    });
    return { ...toRefs(state) };
  },
});
